import { useTooltip } from '../../tooltip/use-tooltip';
import type { ColoredDotProps } from '../dot.component';
import { Dot } from '../dot.component';

export const CriticalDot = ({ hoverText, ...props }: ColoredDotProps) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({ placement: 'top' });
  const { ref, ...rest } = triggerProps;

  return (
    <Dot color='critical' {...props} {...rest} innerRef={ref}>
      <Tooltip {...tooltipProps}>{hoverText}</Tooltip>
    </Dot>
  );
};
